<template>
  <modal transition="pop-out" name="new-suppliers-group-modal" :width="350" :height="200">
    <div class="w-full">
      <form class="rounded px-8 pt-6 pb-8 mb-4" @submit.prevent>
        <div class="mb-4">
          <label class="block text-gray-700 text-sm font-bold mb-2">
            Name
          </label>
          <input v-model="form.name" class="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" type="text" placeholder="Eg: Clothing">
        </div><br>
        <div class="flex justify-around">
          <el-button @click="submit" type="primary" :loading="adding">Save</el-button>
          <el-button @click="closeDialog" type="text">Cancel</el-button>
        </div>
      </form>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'NewSuppliersGroupForm',
  data() {
    return {
      error: false,
      adding: false,
    };
  },
  computed: {
    form() {
      return this.$store.state.InventoryModule.SuppliersGroup.new_suppliers_group;
    },
  },
  methods: {
    async closeDialog() {
      this.$modal.hide('new-suppliers-group-modal');
    },
    async submit() {
      this.errors = this.formValidation(this.form);

      if (this.errors.length === 0) {
        try {
          this.adding = true;

          await this.$store.dispatch('InventoryModule/SuppliersGroup/newSuppliersGroup', { suppliersGroup: this.form });
          this.$modal.hide('new-suppliers-group-modal');
          this.$notify.success({
            title: 'Success',
            message: 'New suppliers group successfully added',
          });
          this.form.name = '';
        } catch (e) {
          this.adding = false;
          this.$notify.error({
            title: 'Error',
            message: 'Something went wrong',
          });
        }

        this.adding = false;
      }
      this.error = false;
    },
  },
};
</script>

<style scoped>

</style>
